module.exports = __webpack_public_path__ + "71decf811e45ac23b84cec6cd740cb31.png";